// Library Methods
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import { SelectChangeEvent } from "@mui/material/Select";
import SelectDropdown from "src/components/shared/inputs/SelectDropdown/SelectDropdown";

// Types
import { UpdateClinicSettingsType } from "src/services/clinics/types";

type ReportLayoutDropdownType = {
  isDisabled: boolean;
  currentSettings: UpdateClinicSettingsType;
  handleUpdateSettings: (settings: UpdateClinicSettingsType) => void;
};

const ReportLayoutDropdown = ({
  isDisabled,
  currentSettings,
  handleUpdateSettings,
}: ReportLayoutDropdownType) => {
  const { t } = useTranslation();

  const reportDropdownOptions = useMemo(
    () => [
      { displayName: t("Single"), value: "Single" },
      { displayName: t("Multiple"), value: "Multiple" },
    ],
    [t]
  );

  const handleSetReportLayout = useCallback(
    (event: SelectChangeEvent<any>) => {
      const value = reportDropdownOptions.find(
        (option) => option.displayName === event.target.value
      )?.value;

      if (value) {
        handleUpdateSettings({
          ...currentSettings,
          monocularReportPdfLayoutOption: value,
        });
      }
    },
    [reportDropdownOptions, currentSettings, handleUpdateSettings]
  );

  return (
    <SelectDropdown
      id="report-layout-dropdown"
      disabled={isDisabled}
      dropdownOptions={reportDropdownOptions}
      value={t(currentSettings.monocularReportPdfLayoutOption)}
      handleChange={handleSetReportLayout}
    />
  );
};

export default ReportLayoutDropdown;
